import { ref, readonly } from 'vue'

export interface CountryData {
  country: string
  countryCht: string
  phoneCode: string
  countryCode: string
  id: number
}

interface CountryApiResponse {
  result: boolean
  content: CountryData[]
}

export const useCountries = () => {
  const countries = ref<CountryData[]>([])
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  const fetchCountries = async (): Promise<void> => {
    if (countries.value.length > 0) {
      // 如果已經載入過，直接返回
      return
    }

    isLoading.value = true
    error.value = null

    try {
      const config = useRuntimeConfig()
      const response = await $fetch<CountryApiResponse>(`${config.public.APIurl}/api/v3/country`)
      
      if (response && response.result) {
        countries.value = response.content || []
      } else {
        throw new Error('Failed to fetch countries')
      }
    } catch (err) {
      console.error('Error fetching countries:', err)
      error.value = err instanceof Error ? err.message : 'Unknown error occurred'
      
      // 提供備用的預設國家列表
      countries.value = [
        {
          id: 1,
          country: 'Taiwan',
          countryCht: '台灣',
          phoneCode: '+886',
          countryCode: 'TW'
        },
        {
          id: 2,
          country: 'United States',
          countryCht: '美國',
          phoneCode: '+1',
          countryCode: 'US'
        },
        {
          id: 3,
          country: 'Japan',
          countryCht: '日本',
          phoneCode: '+81',
          countryCode: 'JP'
        }
      ]
    } finally {
      isLoading.value = false
    }
  }

  // 根據 countryCode 獲取國家資料
  const getCountryByCode = (countryCode: string): CountryData | undefined => {
    return countries.value.find(country => country.countryCode === countryCode)
  }

  // 根據 id 獲取國家資料
  const getCountryById = (id: number): CountryData | undefined => {
    return countries.value.find(country => country.id === id)
  }

  return {
    countries: readonly(countries),
    isLoading: readonly(isLoading),
    error: readonly(error),
    fetchCountries,
    getCountryByCode,
    getCountryById
  }
}